export enum StripeReaderSimulation {
  APPROVE = "APPROVE",
  DECLINE = "DECLINE",
  INSUFFICIENT_FUNDS = "INSUFFICIENT_FUNDS",
  EXPIRED_CARD = "EXPIRED_CARD",
  LOST_CARD = "LOST_CARD",
  STOLEN_CARD = "STOLEN_CARD",
  PROCESSING_ERROR = "PROCESSING_ERROR",
  REFUND_FAIL = "REFUND_FAIL",
  SUCCEED_INPUT_COLLECTION = "SUCCEED_INPUT_COLLECTION",
  TIMEOUT_INPUT_COLLECTION = "TIMEOUT_INPUT_COLLECTION",
}
